<!-- src/components/kakaomap/KakaoMap.vue -->
<template>
  <div class="kmap-wrap">
    <div ref="mapContainer" class="kmap" role="img" aria-label="ICIK 위치 지도"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const mapContainer = ref(null)
let map

const init = () => {
  const center = new kakao.maps.LatLng(37.477875, 126.880649)

  map = new kakao.maps.Map(mapContainer.value, {
    center,
    level: 4,
    mapTypeId: kakao.maps.MapTypeId.ROADMAP,
  })

  // 확대/축소 제어
  map.setZoomable(false)
  const zoomControl = new kakao.maps.ZoomControl()
  map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT)

  const marker = new kakao.maps.Marker({ position: center })
  marker.setMap(map)

  const infowindow = new kakao.maps.InfoWindow({
    content: '<div style="width:150px;text-align:center;padding:6px 0;">한국내부통제협회</div>',
  })
  infowindow.open(map, marker)
}

// 컨테이너 크기 변화 시 카카오맵은 relayout 필요
const onResize = () => {
  if (!map) return
  const currentCenter = map.getCenter()
  map.relayout()
  map.setCenter(currentCenter)
}

onMounted(() => {
  init()
  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})
</script>

<style scoped>
/* 바깥 래퍼: 가운데 정렬 + 최대 너비 */
.kmap-wrap {
  width: 100%;
  max-width: 1200px;   /* 기존 1200px 상한 유지 */
  margin: 0 auto;
}

/* 지도 컨테이너: 가로는 100%, 높이는 화면에 맞춰 유동 */
.kmap {
  width: 100%;
  height: clamp(280px, 45vw, 450px); /* 모바일~데스크톱 자연스러운 스케일 */
  border-radius: 12px;
  overflow: hidden;
}

/* 태블릿(가로/세로)에서 살짝 키움 */
@media (min-width: 768px) and (max-width: 1024px) {
  .kmap { height: 380px; }
}

/* 작은 폰(≤480px)에서 높이 확보 */
@media (max-width: 480px) {
  .kmap { height: 300px; }
}
</style>
